<!--
 * @Author: Yu Weifeng weifeng.yu@gientech.com
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description: 柱状图
 数据格式：
 [
  ["chart","bar1","bar2","bar3"],
  ["Mon"，445，414，392]
  ["Tue"，232，345，789],
 ]
-->
<script>
import ChartBase from '../base.vue';
/******* echarts *********/
import * as echarts from 'echarts/core';
import { DatasetComponent, GridComponent } from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([DatasetComponent, GridComponent, BarChart, CanvasRenderer]);
import { isEmpty, isObject } from 'lodash';

export default {
  name: 'LcChartHistogram',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__histogram']
    };
  },
  created() {
    // preset
  },
  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    // 预设转换函数
    processChartData(data) {
      const options = this.mapOptions;
      let transformData = [];
      // 设置了映射字段 或者 数据里有name和value字段
      if (!isEmpty(options) || (isObject(data[0]) && data[0]['name'] && data[0]['value'])) {
        if ((options && options.type) || data[0]['type']) {
          const groupData = {};
          const dimensionGroup = {};
          data.forEach(item => {
            //分组
            const groupType = item[options?.type || 'type'];
            groupData[groupType] = groupData[groupType] ?? [];
            groupData[groupType].push(item);
            // x轴
            const dimensionGroupType = item[options?.dimension || 'name'];
            dimensionGroup[dimensionGroupType] = dimensionGroup[dimensionGroupType] ?? [];
            dimensionGroup[dimensionGroupType].push(item);
          });

          const groupKeys = Object.keys(groupData);
          transformData.push(['histogram', ...Object.keys(groupData)]);
          Object.keys(dimensionGroup).forEach(dimension => {
            let dimensionDataArray = new Array(groupKeys.length);
            dimensionGroup[dimension].forEach(item => {
              dimensionDataArray[groupKeys.indexOf(item[options?.type || 'type'])] = item[options?.valueMap || 'value'];
            });
            transformData.push([dimension, ...dimensionDataArray]);
          });
        } else {
          transformData.push(['histogram', '']);
          Array.isArray(data) &&
            data.forEach(item => {
              transformData.push([item[options?.dimension || 'name'], item[options?.valueMap || 'value']]);
            });
        }
      } else {
        // echarts dataset格式也是可以解析的
        transformData = data;
      }

      this.chartData = transformData;
    },
    processOptions(options) {
      const series =
        this.chartData[0].length < 3
          ? [options.series[0]]
          : this.chartData[0].length > options.series.length
          ? options.series.concat(
              new Array(this.chartData[0].length - options.series.length - 1).fill(options.series[0])
            )
          : options.series.slice(0, this.chartData[0].length);
      // 没有分组信息时，不需要显示legend
      series.length < 2 && delete options.legend;
      options.series = series;
      this.chartOptions = Object.assign({}, options, {
        dataset: {
          source: this.chartData
        }
      });
    }
  }
};
</script>
